import type { InferenceQuality } from "@/types";

import { SessionInferenceMode } from "../graphql/schema.graphql";
import type { FieldValueTypes } from "../InferenceFormComposer/FieldDefs/FieldValueTypes";
import { FormType2D } from "./forms/2D/types";

export const MIN_SEED = 1;
export const MAX_SEED = 1099511627776;
export const DEFAULT_DENSITY = 1;
export const MIN_DENSITY = 1;
export const MAX_DENSITY = 4;
export const STYLE_WEIGHT_STEP = 5;
export const MIN_STYLE_WEIGHT = 0;
export const MAX_STYLE_WEIGHT = 200;
export const MIN_REFERENCE_SIMILARITY = 0;
export const MAX_REFERENCE_SIMILARITY = 100;
export const DEFAULT_REFERENCE_SIMILARITY = 50;
export const MIN_DENOISING_STEPS = 1;
export const MAX_DENOISING_STEPS = 50;
export const MIN_BASE_SHIFT = 0;
export const MAX_BASE_SHIFT = 12;
export const MIN_MAX_SHIFT = 0;
export const MAX_MAX_SHIFT = 12;
export const MIN_GUIDANCE_SCALE = 2;
export const MAX_GUIDANCE_SCALE = 25;
export const NO_TRANSLATION_PROMPT_LANGUAGE = "";
export const LEGACY_AUTO_DETECT_PROMPT_LANGUAGE_VALUES = [
  "autodetect",
  "auto-detect",
] as const;

type PerformanceType = InferenceQuality;

export const PERFORMANCE_OPTIONS = ["LOW", "MEDIUM", "HIGH"] as const;

export const PERFORMANCE_OPTION_TO_NAME_MAP = new Map<PerformanceType, string>([
  ["LOW", "Fast, Low Quality"],
  ["MEDIUM", "Balanced Quality and Speed"],
  ["HIGH", "Slower, Best Quality"],
]);

// For passing data through routes in new inference form
export type InferenceFormNavigationState = {
  mode: SessionInferenceMode;
  assetId?: string;
  form?: Partial<FormType2D> | Partial<FieldValueTypes>;
};
